import { lazy, useState } from "react";
import { BrowserRouter as AppRouter, Route, Switch } from "react-router-dom";
import BackOfficeRoute from "./BackOfficeRoute";
import UshnoRoute from "./UshnoRoute";
import TuneInRoute from "./TuneInRoute";
import TuneInBoxedRoute from "./TuneInBoxedRoute";
import { useDispatch } from "react-redux";
import { getRadioByName } from "@store/action/radio/RadioAction";
import { getDesignbyRadioid } from "../redux/action/themes/FrontofficeThemeAction";
import SpinnerComponent from "../@core/components/spinner/Fallback-spinner";

const Router = () => {
  const Error = lazy(() => import("@src/views/Error"));
  const radio_id = localStorage.getItem("radio_id");
  const [currentTheme, setCurrentTheme] = useState(
    localStorage.getItem("currentTheme_f")
  );
  const dispatch = useDispatch();
  let myPromise = new Promise(async function (myResolve, myReject) {
    await dispatch(getRadioByName());
    if (radio_id) {
      myResolve();
    } else {
      myReject();
    }
  });
  myPromise.then(
    async function () {
      await dispatch(getDesignbyRadioid());
      await setCurrentTheme(localStorage.getItem("currentTheme_f"));
    },
    async function () {
      location.reload();
    }
  );

  return (
    <AppRouter>
      <Switch>
        <Route
          path="/admin/verify-email/:token"
          component={lazy(() =>
            import("@src/views/BackOffice/authentification/VerifyEmail")
          )}
        />
        <Route
          path="/admin/reset-password/:token"
          component={lazy(() =>
            import("@src/views/BackOffice/authentification/ResetPassword")
          )}
        />
        <Route
          path="/admin/create-account/:id"
          component={lazy(() =>
            import("@src/views/BackOffice/authentification/Account_accept")
          )}
        />

        <Route path="/admin" component={BackOfficeRoute} />

        <Route
          path="/"
          render={() => {
            switch (currentTheme) {
              case "1":
                return <UshnoRoute />;
              case "2":
                return <TuneInRoute />;
              case "3":
                return <TuneInBoxedRoute />;
              default:
                return <SpinnerComponent />;
            }
          }}
        />

        <Route path="*" component={Error} />
      </Switch>
    </AppRouter>
  );
};

export default Router;
